import { isNotEmpty } from '../util/check';
export const formatIndexData = params => {
    const { cmpId, subCmps, isFetching } = params;
    if (!cmpId || isFetching) {
        return { status: 'loading' };
    } 
    let indexData = { status: '' };
    subCmps.forEach(item => {
        switch (item.cmp_type) {
            case 'NavView':
                indexData.NavView = item;
                break;
            case 'IndexView':
                item.sub_cmps.forEach(item => {
                    indexData[item.cmp_type] = item;
                });
                break;
            default:
                break;
        }
    });
    return indexData;
};

export const cmpContext = (indexData,queryUrl) => {
    let cmpContext = {};
    if (isNotEmpty(indexData, ['TableList', 'cmp_data'])) {
        const { viewName,metaObjName,sort_fields: sortFields } = indexData.TableList.cmp_data;
        cmpContext = {
            viewName,
            metaObjName,
            sortData: sortFields,
            searchFormData: indexData.SearchForm
        };
    }
    if (queryUrl.pObjectDataID) {
        cmpContext.pObjectDataID = queryUrl.pObjectDataID;
    }
    return cmpContext;
};

export const indexContext = indexData => {
    if (isNotEmpty(indexData, ['NavView', 'cmp_data', 'currentViewName'])) return { 'viewName': indexData.NavView.cmp_data.currentViewName };
    return {};
};

export const existButton = (indexData = {}) => {
    if(isNotEmpty(indexData, ['ButtonList', 'sub_cmps'])) {
        const cmps = indexData.ButtonList.sub_cmps;
        for(let i = 0; i < cmps.length; i++) {
            if(cmps[i].cmp_data && cmps[i].cmp_data.visible) {
                return true;
            }
        }
    }
    return false;
};

export const hasNavViewData = indexData => {
    return isNotEmpty(indexData,['NavView','cmp_data']);
};


// WEBPACK FOOTER //
// ./src/components/Pages/function.js